
<div
  class="node-port-overlay overlay"
  @drop="onDrop"
  @dragover="dragover"
  @dragenter="dragenter"
  @dragleave="dragleave"
/>
